import { requestApi } from "../apiService";
import { ApiEndpoints } from "../apiEndpoints";

export const RESEND_COOLDOWN_SECONDS = 60;

export function extractRetryAfter(
  errorData: unknown,
  fallback = RESEND_COOLDOWN_SECONDS,
): number {
  const d = errorData as
    | { retryAfter?: unknown; extensions?: { retryAfter?: unknown } }
    | undefined;
  const retryAfter = d?.retryAfter ?? d?.extensions?.retryAfter;
  return typeof retryAfter === "number" ? retryAfter : fallback;
}

export type GetEmailResponse = { email: string | null };
export type ChangeEmailPayload = { newEmail: string; turnstileToken?: string };
export type ConfirmEmailChangeResponse = { email: string };

export const getEmail = async (): Promise<GetEmailResponse> => {
  const response = await requestApi({
    url: ApiEndpoints.GET_EMAIL,
    method: "GET",
  });
  return response.data as GetEmailResponse;
};

export const changeEmail = async (
  payload: ChangeEmailPayload,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.CHANGE_EMAIL,
    method: "POST",
    data: payload,
  });
};

export const confirmEmailChange = async (
  code: string,
): Promise<ConfirmEmailChangeResponse> => {
  const response = await requestApi({
    url: ApiEndpoints.CONFIRM_EMAIL_CHANGE,
    method: "POST",
    data: { code },
  });
  return response.data as ConfirmEmailChangeResponse;
};
